import { styled } from '@mui/material/styles';
import MuiToggleButton from '@mui/material/ToggleButton';

export const StyledToggleButton = styled(MuiToggleButton)({
  backgroundColor: 'white',
  margin: '1px',
  fontSize: '12px',
  lineHeight: '16px',
  textTransform: 'capitalize',
  '&.Mui-selected, &.Mui-selected:hover': {
    color: 'white',
    backgroundColor: 'black',
    fontWeight: 600,
  },
});
